import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title p-grid" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-12" }, " Promedio Staff ", -1)
const _hoisted_3 = { class: "p-col-12" }
const _hoisted_4 = { class: "p-grid" }
const _hoisted_5 = { class: "p-col-4 p-sm-12 p-md-12 p-lg-4" }
const _hoisted_6 = { class: "p-col-8 p-sm-12 p-md-12 p-lg-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!
  const _component_PerformanceDetails = _resolveComponent("PerformanceDetails")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "ch-card chart-card h100",
    id: "PerformanceStaffInfo"
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Divider, { class: "divider" })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_PerformanceDetails, {
            isFinishied: $props.isFinishied,
            teachersWithRating: $props.teachersWithRating,
            tutorsWithRating: $props.tutorsWithRating,
            title: "Profesores",
            value: $props.teachersValue,
            teacher: "true",
            summary: $props.teachersSummary
          }, null, 8, ["isFinishied", "teachersWithRating", "tutorsWithRating", "value", "summary"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_PerformanceDetails, {
            isFinishied: $props.isFinishied,
            teachersWithRating: $props.teachersWithRating,
            tutorsWithRating: $props.tutorsWithRating,
            title: "Tutores",
            value: $props.tutorsValue,
            summary: $props.tutorsSummary
          }, null, 8, ["isFinishied", "teachersWithRating", "tutorsWithRating", "value", "summary"])
        ])
      ])
    ]),
    _: 1
  }))
}